import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import OwlCarousel from 'react-owl-carousel2';
import animations from './animations';
import Heading from "../../elements/Heading";

class About extends Component {

    constructor(props) {
        super(props);

        this.sceneController = null;
        this.state = {
            items: []
        };
    }

    componentDidMount() {
        this.sceneController = animations.initialise(this, this.subTitleRef);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                items: this.props.data.items
            });
        }
    }

    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }

    render() {
        const Items = this.state.items.map((item, key) => {
            return (
                <div key={key} className="cube col-md-6"><div className="text">{item}</div></div>
            );
        });

        const options = {
            items: 1,
            loop: false,
            autoHeight: false,
            autoplay: false
        };

        return (
            <section className="about">
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 col-xs-12 centered">
                        <Heading
                            title={this.props.data.title}
                            subTitle={this.props.data.subTitle}
                            setSubTitleRef={this.setSubTitleRef}
                        />
                        <div className="row cubes">
                            <BrowserView>
                                {Items}
                            </BrowserView>
                            <MobileView>
                                {this.state.items.length > 0 ?
                                    <OwlCarousel options={options}>
                                        {Items}
                                    </OwlCarousel>
                                : ''}
                            </MobileView>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
    
}

export default About;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/About/About.js